import {
  ApplicationConfig,
  CSP_NONCE,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from "@angular/core";
import {MainModule} from "./app/main/main.module";
import {MAT_SNACK_BAR_DEFAULT_OPTIONS} from "@angular/material/snack-bar";
import {Angular2PromiseButtonModule} from "./app/angular2-promise-buttons/angular2-promise-buttons.module";
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi, withXhr} from "@angular/common/http";
import {DATE_PIPE_DEFAULT_OPTIONS} from "@angular/common";
import {systemDateKey} from "./app/main/admin/toggles/storageKeys";
import {provideRouter} from "@angular/router";
import {routes} from "./app/app.routes";
import {provideTranslateService} from "@ngx-translate/core";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import {translateFolderId} from "../buildVars";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {authInterceptor} from "./app/auth/auth-interceptor";
import {errorInterceptor} from "./app/auth/error-interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideHttpClient(withXhr(), 
      withInterceptors([
        authInterceptor,
        errorInterceptor
      ])
    ),
    importProvidersFrom(MainModule,
      Angular2PromiseButtonModule.forRoot({
        disableBtn: true,
        btnLoadingClass: 'is-spinning',
        spinnerTpl: '<span class="spinner"></span>'
      })),
    provideRouter(routes),
    provideTranslateService({
      loader: provideTranslateHttpLoader({prefix:`/assets/i18n/${translateFolderId}/`, suffix:'.json'}),
      fallbackLang: 'en'
    }),
    {
      provide: CSP_NONCE,
      useValue: (document.querySelector('meta[name="CSP-NONCE"]') as any).content
    },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 5000 } },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useFactory: () => {
        const useSystemDate = localStorage.getItem(systemDateKey) === 'true';
        return {dateFormat: useSystemDate ? undefined : 'dd.MM.yyyy HH:mm'}
      }
    },
  ]
};
